export function setMenu(state, menu) {
  state.menu = menu; 
}

export function menuError(state, payload){
  state.error = true
  state.errorMessage = payload
}

export function setFooterMenu(state, footerHtml) {
  state.footerMenu = footerHtml; 
}
